import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LngDetector from "i18next-browser-languagedetector";
import translationFR from './translations/fr.json';
import translationNL from './translations/nl.json';
import translationEN from './translations/en.json';

// the translations
const resources = {
    fr: {
        translation: translationFR
    },
    nl: {
        translation: translationNL
    },
    en: {
        translation: translationEN
    }
};

const detectionOptions = {
    order: ['path', 'cookie', 'navigator', 'localStorage', 'subdomain', 'queryString', 'htmlTag'],
    lookupFromPathIndex: 0

}

i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .use(LngDetector)
    .init({
        resources,

        detection: detectionOptions,
        keySeparator: false, // we do not use keys in form messages.welcome

        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });

export default i18n;